import { createContext } from 'react';

const ConfigContext = createContext();

export { ConfigContext };
